import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './PaymentSuccess.css';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      fetch(`${API_URL}/api/payment/verify-session/${sessionId}`)
        .then(res => res.json())
        .then(data => {
          setSessionData(data);
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [sessionId, API_URL]);

  if (loading) {
    return (
      <div className="payment-success-page">
        <div className="loading-spinner"></div>
        <p>Verifying your payment...</p>
      </div>
    );
  }

  return (
    <div className="payment-success-page">
      <div className="success-card">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" fill="none"/>
            <path d="M8 12l2 2 4-4" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1>Payment Successful!</h1>
        <p className="thank-you">Thank you for your purchase.</p>
        {sessionData && (
          <div className="session-details">
            <div className="detail-item">
              <span className="detail-label">Email:</span>
              <span className="detail-value">{sessionData.customerEmail}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Amount:</span>
              <span className="detail-value">${sessionData.amountTotal} USD</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Status:</span>
              <span className="detail-value status-paid">{sessionData.status}</span>
            </div>
          </div>
        )}
        <div className="action-buttons">
          <button onClick={() => navigate('/')} className="back-btn primary">
            Back to Home
          </button>
          <button onClick={() => navigate('/management')} className="back-btn secondary">
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
